$(document).ready(function() {
    $('.product-form__submit[name="add"]').attr("disabled", true);

    function s3Upload(blob) {
        const response = new Promise (function (resolve, reject) {
            var bucketName = "newbornposter";
            var bucketRegion = "us-east-1";
            var IdentityPoolId = "us-east-1:f9ca8273-bd68-474e-a0b3-5fc3e4063d87";
            var image_url = "";
        
            AWS.config.update({
            region: bucketRegion,
            credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: IdentityPoolId })
            });

            var s3 = new AWS.S3({
            apiVersion: '2012-10-17',
            params: {Bucket: bucketName}
            });

            var params = {
                Key: Date.now() + "." + blob.type.split("/")[1],
                Body: blob,
                ContentType: blob.type,
                ACL: 'public-read'
            }

            s3.upload(params, function(err, data) {
                if(err) {
                    console.log("checking error", err);
                    reject(err);
                } else {
                    image_url = data.Location;
                    resolve(image_url);
                }
            });
        })

        return response;
    }

    function getLayoutClasses(index, classNames) {
        var current_classes = classNames.split(" "), classes_to_remove = []; 
        
        $.each(current_classes, function (index, class_name) {
          if (/^layout-.*/.test(class_name)) {classes_to_remove.push(class_name);}
        });
    
        return classes_to_remove.join(" ");
    }

    // Emoji strip utility — strips emoji characters from a string
    function stripEmojis(str) {
        return str.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu, '');
    }

    $('#bp-photo-heading').on('input change', function(){
        let heading = stripEmojis($(this).val());

        $(this).val(heading.toUpperCase());
        $('.bp-poster-headline .bp-photo-heading').text(heading.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-photo-subheading').on('input change', function(){
        let subheading = stripEmojis($(this).val());

        $(this).val(subheading.toUpperCase());
        $('.bp-poster-subheading .bp-photo-subheading').text(subheading.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-subheading');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('.ptp-layout-radio').on('change', function(){
        let layout = $(this).attr("data-layout");

        if(layout == "infinite") {
            $('.bp-sidebar-object:has(.photo-text-color)').removeClass("hide")
        }
        else {
            $('.bp-sidebar-object:has(.photo-text-color)').addClass("hide");
            $(`.ptp-color-radio[value="black"]`).prop("checked", true);
            $(`.ptp-color-radio:checked`).change();
        }

        $('.birthposter-template').removeClass(getLayoutClasses);
        $('.birthposter-template').addClass(`layout-${layout}`);

        $('.hidden-preview').removeClass(getLayoutClasses);
        $('.hidden-preview').addClass(`layout-${layout}`);
    });

    $('.ptp-color-radio').on('change', function(){
        let color = $(this).val();

        $('.bp-poster-headline').css('color', color);
        $('.bp-poster-subheading').css('color', color);
    });

    $('.ptp-filter-radio').on('change', function(){
        let filter = $(this).val();

        if(filter == 'original') {
            $('.ptp-filter-range').attr("disabled", true)
            $('.ptp-filter-range').val(100)
        }
        else {
            $('.ptp-filter-range').attr("disabled", false)
            let val = localStorage.getItem($('.ptp-filter-range').attr("name")) || 100;
            $('.ptp-filter-range').val(val)
        }
        $('.bp-illustration-filter-img').attr("src", $(this).attr("data-url"));
        $('.bp-illustration-img').attr("src", $(this).attr("data-original"));
    });

    $('.ptp-filter-range').on('input change', function(){
        let val = $(this).val();
        $('.ptp-filter-range-value').text(`${val}%`)
        $('.bp-illustration-filter-img').css("opacity", `${val}%`)
    });

    $('.bp-start-over-btn').on('click', function() {
        $('.photo-selector-popup').attr("aria-hidden", false)
    });

    function isNewFormat(text) {
        const regex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
        return regex.test(text);
    }

    $('.photoposter-session').on('change', function(){
        let session = $(this).val();
        let filter_names = ['original', 'bright', 'vintage', 'summer', 'clarendon', 'gingham', 'rise', 'gray', 'inkwell', 'willow'];
        let filters = []
        if(isNewFormat(session)) {
            filters = filter_names.map((item) => { return {"id": item, "url": `https://media.birthbox.se/storage/photoposters/${session}/image_${item}.jpg`}});
        }
        else {
            filters = filter_names.map((item) => { return {"id": item, "url": `https://filter.thephotoposter.com/filter/session/${session}/image_${item}.jpg`}});
        }
        let original_image = filters[0].url;
        filters.forEach(filter => {
            $(`.ptp-filter-radio[value="${filter.id}"]`).attr("data-url", filter.url);
            $(`.ptp-filter-radio[value="${filter.id}"]`).attr("data-original", original_image);
            $(`.filter-radio-${filter.id}`).attr("src", filter.url);
        });
        $('.ptp-filter-radio:checked').change();
        $('.product-form__submit[name="add"]').attr("disabled", false);
    });    

    let fileDropZone = document.querySelector('.photo-selector-container');
    let photoInput = document.querySelector('.photposter-photo-input');

    fileDropZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        fileDropZone.classList.remove('error');
        fileDropZone.classList.add('dragover');
    });
    
    fileDropZone.addEventListener('dragleave', () => {
        fileDropZone.classList.remove('error');
        fileDropZone.classList.remove('dragover');
    });

    fileDropZone.addEventListener('click', () => {
        photoInput.click();
    });

    fileDropZone.addEventListener('drop', async (e) => {
        e.preventDefault();

        if(e.dataTransfer.items[0].kind !== "file") {
            fileDropZone.classList.add('error');
            throw new Error("Not a file")
        }

        if(e.dataTransfer.items.length > 1) {
            fileDropZone.classList.add('error');
            throw new Error("Mutiple items uploaded")
        }

        const filesArray = [...e.dataTransfer.files]

        const isFile = await new Promise((resolve) => {
            const fr = new FileReader();
            fr.onprogress = (e) => {
                if (e.loaded > 50) {
                    fr.abort();
                    resolve(true);
                }
            }
            fr.onload = () => { resolve(true) }
            fr.onerror = () => { resolve(false) }
            fr.readAsArrayBuffer(e.dataTransfer.files[0]);
        })

        if(!isFile) {
            fileDropZone.classList.add('error');
            throw new Error("Not a file")
        }

        const allowedtypes = photoInput.getAttribute("accept")

        if(!allowedtypes.includes(filesArray[0].type)) {
            fileDropZone.classList.add('error');
            throw new Error("File type not allowed")
        }

        fileDropZone.classList.remove('error');
        fileDropZone.classList.remove('dragover');

        photoInput.value = '';
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(filesArray[0]);
        photoInput.files = dataTransfer.files;
        
        handleFiles(filesArray);
    });

    photoInput.addEventListener('change', (e) => {
        const files = e.target.files;
        handleFiles(files);
    });

    const image = document.getElementById('photo-cropper');
    let cropper = {}
    let containerData = {};
    let canvasData = {};

    async function handleFiles(files) {
        const maxFileSize = 20 * 1024 * 1024;
        if (files.length > 0) {
            fileDropZone.classList.remove('error');
            let file = files[0]
            if (file.size > maxFileSize) {
                fileDropZone.classList.add('error');
                photoInput.value = '';
            }
            else {
                const start_loading = () => {
                    $('.photoposter-selector-btn').prop('disabled', true);
                    $('.photoposter-selector-btn').attr('aria-disabled', true);
                    $('.photoposter-selector-btn').addClass('loading');
                    $('.photoposter-selector-btn').find('.loading__spinner').removeClass('hidden');
                    $('.photoposter-selector-btn').closest('.bp-popup').find('.bp-popup-close').attr('aria-disabled', true);
                }

                const end_loading = () => {
                    $('.photoposter-selector-btn').prop('disabled', false);
                    $('.photoposter-selector-btn').attr('aria-disabled', false);
                    $('.photoposter-selector-btn').removeClass('loading');
                    $('.photoposter-selector-btn').find('.loading__spinner').addClass('hidden');
                    $('.photoposter-selector-btn').closest('.bp-popup').find('.bp-popup-close').attr('aria-disabled', false);
                }


                if (file.type === 'image/heic') {
                    start_loading();
                    photoInput.disabled = true;
                    try {
                        await new Promise(resolve => setTimeout(resolve, 500));
                        const arrayBuffer = await file.arrayBuffer();
                        const uint8Array = new Uint8Array(arrayBuffer);
                        const { HeifDecoder } = libheif();
                        const decoder = new HeifDecoder();
                        const data = decoder.decode(uint8Array);

                        const image = data[0];
                        const width = image.get_width();
                        const height = image.get_height();

                        const canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;
                        const context = canvas.getContext('2d');
                        const imageData = context.createImageData(width, height);

                        await new Promise((resolve, reject) => {
                            image.display(imageData, (displayData) => {
                            if (!displayData) {
                                return reject(new Error('HEIF processing error'));
                            }
                            resolve();
                            });
                        });

                        context.putImageData(imageData, 0, 0);
                        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 1));
                        // const blob = await heic2any({
                        //     blob: file,
                        //     toType: 'image/jpeg',
                        // });
                        let newFile = new File(
                            [blob], 
                            file.name.replace(/\.[^/.]+$/, ".jpg"), 
                            { type: 'image/jpeg' }
                        );
                        file = newFile;
                        photoInput.disabled = false;

                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file);
                        photoInput.value = '';
                        photoInput.files = dataTransfer.files;

                    } catch (error) {
                        console.error('Error converting HEIC to JPEG:', error);
                        photoInput.disabled = false;
                        fileDropZone.classList.add('error');
                        photoInput.value = '';
                        end_loading();
                        return;
                    }
                    end_loading();
                }

                const objectURL = URL.createObjectURL(file);
                image.src = objectURL;
                let aspectRatio = parseFloat($('.ptp-orientation-radio:checked').attr("data-orientation"));
                cropper = new Cropper(image, {
                    viewMode: 1,
                    dragMode: 'move',
                    initialAspectRatio: aspectRatio,
                    aspectRatio: aspectRatio,
                    modal: true,
                    guides: true,
                    background: false,
                    autoCrop: true,
                    autoCropArea: 1, 
                    cropBoxMovable: false,
                    cropBoxResizable: false,
                    toggleDragModeOnDblclick: false,
                    ready() {
                        containerData = cropper.getContainerData();
                        canvasData = cropper.getCanvasData();
                    }
                });
        
                $('.photo-selector-container').addClass("hide");
                $('.photo-cropper-container').removeClass("hide");
            }
        }
    }

    const sizes = $('#variant-sizes').val().split(',');
    let dpiObject = {}
    let size_factors = {
        "30x40": {
            "height": 0.815,
            "width": 0.815
        },
        "50x70": {
            "height": 0.815,
            "width": 0.815
        },
        "70x100": {
            "height": 0.96,
            "width": 0.96
        }
    }

    image.addEventListener("crop", (event) => {
        let width = event.detail.width;
        let height = event.detail.height;

        sizes.forEach(size => {
            let size_factor_width = size_factors[size].width || 0.82;
            let size_factor_height = size_factors[size].height || 0.835;

            let orientation = $('.ptp-orientation-radio:checked').val();
            let sizeWidth =  parseFloat(size.toLowerCase().split("x")[0]) * size_factor_width
            let sizeHeight =  parseFloat(size.toLowerCase().split("x")[1]) * size_factor_height
            if (orientation == "landscape") {
                sizeWidth =  parseFloat(size.toLowerCase().split("x")[1]) * 0.87
                sizeHeight =  parseFloat(size.toLowerCase().split("x")[0]) * 0.769
            }
            sizeWidth = sizeWidth/ 2.54; 
            sizeHeight = sizeHeight/ 2.54;
            
            let dpiWidth = width / sizeWidth;
            let dpiHeight = height / sizeHeight;

            let sizeDpi = parseInt(Math.round(Math.min(dpiWidth, dpiHeight)));
            $(`.image-quality-item[data-variant="${size}"] .image-quality-dpi`).text(`${sizeDpi} DPI`)
            if(sizeDpi > 100) {
                $(`.image-quality-item[data-variant="${size}"] .image-quality-icon`).addClass('approved')
            }
            else {
                $(`.image-quality-item[data-variant="${size}"] .image-quality-icon`).removeClass('approved')
            }
            dpiObject[size] = sizeDpi
        });
    });

    $('.ptp-orientation-radio').on('change', function(){
        let ratio = parseFloat($(this).attr("data-orientation"));
        cropper.setAspectRatio(ratio);
    });

    $('.current_orientation').on('change', function(){
        let orientation = $(this).val();

        if(orientation == "landscape" && $('.ptp-layout-radio:checked').attr("data-layout") == "arch") {
            $('.ptp-layout-radio[data-layout="classic"]').prop("checked", true);
            $('.ptp-layout-radio:checked').change();
        }
        $('.birthposter-template').removeClass(`bp_portrait`);
        $('.birthposter-template').removeClass(`bp_landscape`);
        $('.birthposter-template').addClass(`bp_${orientation.toLowerCase()}`);

        $('.hidden-preview').removeClass(`bp_portrait`);
        $('.hidden-preview').removeClass(`bp_landscape`);
        $('.hidden-preview').addClass(`bp_${orientation.toLowerCase()}`);

        $('.bp-frame-radio:checked').change();
    });

    $('.size_disabler').on('change', function(){
        let size_disabler_string = $(this).val();
        let current_size = $('#current-size').val();

        Array.from(size_disabler_string).forEach((letter, index) => {
            let disabled = true;
            let curr_size = sizes[index]
            if (letter == "t") disabled = false;
            if(current_size == curr_size) $('.product-form__submit[name="add"]').attr("disabled", disabled);
            $(`.bp-variant-options-radio[value="${curr_size}"]`).attr("disabled", disabled);
        });
    });

    $('.ptp-zoom-range').on('input change', function(){
        let val = $(this).val();
        let zoom_value = (canvasData.width / canvasData.naturalWidth) + parseFloat(val)

        cropper.zoomTo(zoom_value, {
            x: containerData.width / 2,
            y: containerData.height / 2,
        });
    });

    $('.cropper-save-btn').on('click', function(){
        let current_file = photoInput.files[0];
        let data = cropper.getData(true);
        
        const start_loading = () => {
            $(this).prop('disabled', true);
            $(this).attr('aria-disabled', true);
            $(this).addClass('loading');
            $(this).find('.loading__spinner').removeClass('hidden');
            $(this).closest('.bp-popup').find('.bp-popup-close').attr('aria-disabled', true);
            $('.cropper-start-over-btn').prop('disabled', true);
        }

        let orientation = $('.ptp-orientation-radio:checked').val();
        let curr_dpi_object = dpiObject;

        const end_loading = () => {
            let size_disabler_string = ""
            sizes.forEach(size => {
                let curr_dpi = curr_dpi_object[size] || 0;
                if (curr_dpi > 100) {
                    size_disabler_string = size_disabler_string + "t"
                }
                else {
                    size_disabler_string = size_disabler_string + "f"
                }
            });
            $(".size_disabler").val(size_disabler_string).change();
            $('.current_orientation').val(orientation).change();
            $('.bp-save-for-later-btn').removeClass("hide");

            $(this).prop('disabled', false);
            $(this).attr('aria-disabled', false);
            $(this).removeClass('loading');
            $(this).find('.loading__spinner').addClass('hidden');
            $(this).closest('.bp-popup').find('.bp-popup-close').attr('aria-disabled', false);
            $('.cropper-start-over-btn').prop('disabled', false);

            cropper.destroy();
            $('.photo-cropper-container').addClass("hide");
            $('.photo-selector-container').removeClass("hide");
            $('.photo-selector-popup').attr("aria-hidden", 'true');
            photoInput.value = '';
        }

        if (current_file) {
            start_loading();
            s3Upload(current_file).then((url) => {
                console.log(url)
                // let api_call = `https://filter.thephotoposter.com/filter/pdfmotor.php?session_start&template=photoposter&x=${data.x}&y=${data.y}&w=${data.width}&h=${data.height}&url=${url}&=tokenf1d53b4b526ab37565bc7b1f21016946:a5ae6f9112a313c982fd27d1f531b6492aeabe9592535e2a91b57572c8642700`
                let api_call = `https://media.birthbox.se/get-media?template=photoposter&x=${data.x}&y=${data.y}&w=${data.width}&h=${data.height}&url=${url}`;
                fetch(api_call)
                .then(response => response.json())
                .then(data => {
                    let session = data.session;
                    setTimeout(() => {
                        $(".photoposter-session").val(session).change();
                        end_loading(); 
                    }, (data.wait*1000))
                })
                .catch(error => { 
                    console.error('Error:', error);
                    end_loading(); 
                });
            }).catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                end_loading();
            });
        }
    });

    $('.cropper-start-over-btn').on('click', function(){
        cropper.destroy();
        $('.photo-cropper-container').addClass("hide");
        $('.photo-selector-container').removeClass("hide");
        photoInput.value = '';
    });
});